import { Outlet } from 'react-router-dom';
import { LeadProvider } from 'components/Leads/context/LeadProvider';

const LeadWrapper = () => {
  return (
    <LeadProvider> 
      <Outlet />
    </LeadProvider> 
  );
};

export default LeadWrapper;